class RepaymentRepository {
  constructor(repTime = [], defaultValue = 1) {
    this.mountLabel = 'mån';
    this.yearLabel = 'år'
    this.data = this.parseRepayment(repTime)
    this.defaultIndex = this.searchDefaultIndex(this.data, defaultValue);
  }

  parseRepayment(repTime) {
    return repTime.map((x,i) => {
      return  {
        label: x % 12 !== 0? `${x}${i === repTime.length - 1? '+' : ''} ${this.mountLabel}` : `${x / 12}${i === repTime.length - 1? '+' : ''} ${this.yearLabel}`,
        value: x,
      }
    });
  }

  searchDefaultIndex(data, defaultValue) {
    return data.findIndex((x) => x.value === parseInt(defaultValue))
  }
}

export default RepaymentRepository;



// WEBPACK FOOTER //
// ./scripts/libs/RepaymentRepository.js